import React from "react";

const SectionList = ({ sections, selectedSection, onSectionSelect }) => {
  return (
    <div className="grid grid-cols-5  rounded-t-[10px] overflow-hidden p-1 max-h-[150px] overflow-y-auto">
      {sections.map((section) => (
        <div
          key={section.sectionId}
          className={`relative
        h-10
        px-2
        flex
        items-center
        justify-center
        text-[13px]
        font-medium
        cursor-pointer
        rounded-xl
        mx-1
        my-1
        transition-all
        duration-200
        ease-in-out
        border border-[#3BA2B959] ${
          selectedSection === section.sectionId
            ? "bg-[#06513D] text-white shadow-md transform scale-105"
            : "bg-transparent text-gray-700 hover:text-gray-900"
        }`}
          onClick={() => onSectionSelect(section.sectionId)}
        >
          <span className="text-center leading-tight">{section.name}</span>
        </div>
      ))}
    </div>
  );
};

export default SectionList;
